import React from 'react';
import MainMenu from '../../components/main-menu/main-menu';
import { Routes, Route } from 'react-router-dom';
import DeviceView from './device-view/device-view';
import OptionsView from './options-view/options-view';
import RotationView from "./rotation-view/rotation-view";
import AlarmsView from "./alarms-view/alarms-view";

const SettingsView: React.FC = () => {

    return (
        <div className='d-flex main-cointainer'>
            <MainMenu />
            <Routes>
                <Route path="/" element={<DeviceView />} />
                <Route path="device/*" element={<DeviceView />} />
                <Route path="options/*" element={<OptionsView />} />
                <Route path="rotation" element={<RotationView />} />
                <Route path="alarms/*" element={<AlarmsView />} />
            </Routes>
        </div>
    )
}

export default SettingsView;
